module.exports = __webpack_public_path__ + "static/certificate3-be03a73e0dffe692688a65a6ac460be7.pdf";